import { Trans } from 'react-i18next'

import { IActionFormProps } from '@makyoapp/makyo-common'
import { Button, ButtonVariant, Field, Label } from '@makyoapp/makyo-ui'

import { useForm } from '@/lib/use-form'
import { ActionInputdata } from '@/shared/action.types'
import { ActionInputV3 } from '@/components/ActionInputV3/ActionInputV3'

export default function ActFormClipboard({ onSubmit, onDismiss, initialData }: IActionFormProps) {
  const { form, onSubmit: onFormSubmit } = useForm<ActionInputdata>({
    defaultValues: {
      ...((initialData || {}) as ActionInputdata),
    },
    validate(data, setError) {
      let isEmpty = !data.value?.trim().length
      setError('value', isEmpty ? 'Value cannot be empty' : null)
    },
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  const value = form.getValues('value')
  const invalidForm = !value || !!form.errors

  return (
    <div>
      <div className='p-4'>
        <Field>
          <Label required>Value</Label>

          <ActionInputV3
            options={initialData?.actionOptions}
            isActionWorkflow={initialData?.isActionWorkflow}
            value={form.getValues()}
            onChange={(value) => {
              form.setValues(value)
            }}
            error={form.errors?.value}
          />
        </Field>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit} disabled={invalidForm}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  )
}
